<script lang="ts">
	import TooltipIcon from 'assets/svg/tooltip.svg?component';
	import Tooltip from 'components/Tooltip/Tooltip.svelte';
	import type { formatType } from './types';
	import activeCurrency from 'stores/activeCurrency';
	import formatNumber from 'utils/formatNumber';

	export let data: number | string;
	export let text: string;
	export let showTooltip: boolean = false;
	export let format: formatType = 'currency';
	export let dark: boolean;
	export let tooltipText: string;
	export let isRecalculating = true;
	export let isHTML = false;
	export let isFiatValueOnly = false;

	$: currencyData = $activeCurrency;

	const shortValueToggleAmount = 9999999999;
</script>

<div class="stat-item" class:dark>
	<div class="stat-wrapper">
		<p class="stat-description">
			{text}
			{#if showTooltip}
				<TooltipIcon class="hint-icon" width="12" height="12" />
				<Tooltip {dark} text={tooltipText} class="stat-tooltip" {isHTML} />
			{/if}
		</p>
	</div>
	<span class="stat-data">
		{#key currencyData}
			{formatNumber(
				isRecalculating ? Number(data) * currencyData.price : Number(data),
				isFiatValueOnly ? 'USD' : currencyData.currency.toUpperCase(),
				data > shortValueToggleAmount,
				format,
			) || '--'}
		{/key}
	</span>
</div>

<style lang="scss">
	@import 'statisticItem';
</style>
